export default __webpack_public_path__ + "static/media/SELLOS_06.985fef44.png";